import React from 'react'
import { styled, productUtils, context, CartProduct, Link } from '@tools/wr-catalog-base'
import { renderPrice } from '@utils/product-utils'

const StyledCartProduct = styled(CartProduct)`
  padding-left: 20px;
  margin: 0;
  min-width: 300px;

  ${CartProduct.RemoveFromCart} svg {
    color: red;
    opacity: 1;
  }

  svg {
    margin-left: 0;
  }
  a {
    color: ${({ theme }) => theme.palette.primary} !important;
    padding: 0;
  }
  .cart-product-name,
  .cart-product-price {
    font-size: inherit;
  }
`

const PriceContainer = styled.span`
  color: var(--color-green);
  font-weight: bold;
`

export default function PtcCartProduct(props) {
  const { cartProduct } = props
  const price = productUtils.getPrice(cartProduct, true)

  return (
    <StyledCartProduct
      product={cartProduct}
      price={price}
      renderPrice={(...args) => <PriceContainer>{renderPrice(...args)}</PriceContainer>}
      renderName={({ props }) => {
        const {
          product: { id, name },
        } = props
        const url = context.getRoutePath('productDetail', { productId: id })
        return (
          <Link to={url} rel="noopener noreferrer">
            {name}
          </Link>
        )
      }}
      renderProductSummary={(product) => {
        const outcome = product.rows.find((row) => row.options.tag === '<Outcome>') || {}
        return <div dangerouslySetInnerHTML={{ __html: outcome.control || product.description }} />
      }}
    />
  )
}
